module.exports = __webpack_public_path__ + "img/goods12_2.5d9ad976.jpg";